import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-horario-materias-lista',
  standalone: false,
  templateUrl: './horario-materias-lista.component.html',
  styleUrls: ['./horario-materias-lista.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HorarioMateriasListaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
